import {
  Box,
  BoxProps,
  Flex,
  Heading,
  mdBumps,
  PrimaryButton,
} from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { CustomerAccount, PaymentMethod } from '../../../../../domain'
import { useSetupMandate } from '../../../../../hooks/directDebit'
import {
  TKey,
  tPaymentMethods,
  useWriskTranslation,
} from '../../../../../infrastructure/internationalisation'

const tKey = TKey('components.direct-debit-setup')

export interface DirectDebitSetupProps extends BoxProps {
  context?: string
  customerAccount: CustomerAccount
  mandate: PaymentMethod | undefined
}

export const DirectDebitSetup: FunctionComponent<DirectDebitSetupProps> = ({
  context,
  customerAccount,
  mandate,
  ...props
}) => {
  const { t } = useWriskTranslation()

  const onSetupMandate = useSetupMandate(customerAccount, context)

  return (
    <Box width={1} variant='raised' px={mdBumps} py={5} {...props}>
      {mandate ? (
        <Heading>
          {t(tPaymentMethods('bacs', 'redacted'), {
            bankName: mandate.bankName,
            accountNumberEnding: mandate.bankAccountNumberEnding,
          })}
        </Heading>
      ) : (
        <Flex>
          <Heading>{t(tKey('header'))}</Heading>
          <PrimaryButton
            data-testid='setup-direct-debit'
            layout='small'
            onClick={onSetupMandate.execute}
            disabled={onSetupMandate.loading}
          >
            {t(tKey('actions.add'))}
          </PrimaryButton>
        </Flex>
      )}
    </Box>
  )
}
